var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurebaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.6843 28.6992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.6992,
    opacity: 0,
    width: 20.6843,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23472 7.48828C10.641 7.48828 11.7777 6.35156 11.7777 4.93359C11.7777 3.52734 10.641 2.39062 9.23472 2.39062C7.80503 2.39062 6.66831 3.52734 6.66831 4.93359C6.66831 6.35156 7.80503 7.48828 9.23472 7.48828ZM2.76597 28.4648C3.42222 28.582 4.0316 28.1484 4.1605 27.4688L5.27378 21.4805L9.93785 18.9492C10.0668 18.8672 10.1839 18.9023 10.2425 19.0312L12.598 24.7148C12.7386 25.0195 12.9496 25.2305 13.2191 25.3711L18.516 28.3125C19.1839 28.6992 19.8871 28.3828 20.1683 27.8555C20.5082 27.2812 20.2855 26.5195 19.6996 26.1914L14.766 23.4609L11.4261 10.0898C11.2269 9.29297 10.5355 8.71875 9.68003 8.71875L2.51988 8.71875L5.87144 1.59375C6.32847 0.632812 5.63706 0 4.93394 0C4.5355 0 4.14878 0.199219 3.94956 0.691406L0.0823773 10.7695C-0.105123 11.25 0.0472211 11.6953 0.34019 11.9883L3.32847 14.9883C3.7855 15.4336 4.57066 15.4336 5.02769 14.9883L6.35191 13.6523C6.52769 13.4766 6.79722 13.4766 6.86753 13.7344L7.58238 16.6055L3.44566 19.7109C3.15269 19.9336 3.02378 20.2852 2.95347 20.6133L1.79331 27.0469C1.67613 27.6797 2.10972 28.3359 2.76597 28.4648ZM5.41441 11.1328L4.17222 12.375L2.93003 11.1328Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurebaseball);
export default __webpack_public_path__ + "static/media/figure.baseball.b92c1a11cd22488c6b1042f734a0c28d.svg";
export { ForwardRef as ReactComponent };